/**
 * Generated by orval v7.5.0 🍺
 * Do not edit manually.
 * WorkOS Widgets
 * WorkOS Widgets API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import { useWidgetsApiClient } from "./widgets-api-client";
import { useWidgetsApiQueryOptions } from "./widgets-api-client";
export const MemberStatus = {
    Active: "Active",
    Invited: "Invited",
    InviteExpired: "InviteExpired",
    InviteRevoked: "InviteRevoked",
    NoInvite: "NoInvite",
};
export const MemberActionsItem = {
    "edit-role": "edit-role",
    "resend-invite": "resend-invite",
    "revoke-invite": "revoke-invite",
    "revoke-membership": "revoke-membership",
};
export const CreateTotpFactorResponseAuthenticationFactorAllOfObject = {
    authentication_factor: "authentication_factor",
};
export const CreateTotpFactorResponseAuthenticationFactorAllOfType = {
    generic_otp: "generic_otp",
    sms: "sms",
    totp: "totp",
    webauthn: "webauthn",
};
export const CreateTotpFactorResponseAuthenticationChallengeAllOfObject = {
    authentication_challenge: "authentication_challenge",
};
export const AuthenticationInformationResponseDataVerificationMethodsMfaProvider = {
    MFA: "MFA",
};
export const AuthenticationInformationResponseDataVerificationMethodsPasswordProvider = {
    Password: "Password",
};
export const AuthenticationInformationResponseDataVerificationMethodsPasskeyProvider = {
    Passkey: "Passkey",
};
export const SendVerificationResponseType = {
    EmailVerification: "EmailVerification",
};
export const useMembersHook = () => {
    const members = useWidgetsApiClient();
    return useCallback((params, signal) => {
        return members({
            url: `/_widgets/UserManagement/members`,
            method: "GET",
            params,
            signal,
        });
    }, [members]);
};
export const getMembersQueryKey = (params) => {
    return [
        `/_widgets/UserManagement/members`,
        ...(params ? [params] : []),
    ];
};
export const useMembersQueryOptions = (params, options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getMembersQueryKey(params);
    const members = useMembersHook();
    const queryFn = ({ signal }) => members(params, signal);
    const customOptions = useWidgetsApiQueryOptions({
        ...queryOptions,
        queryKey,
        queryFn,
    });
    return customOptions;
};
export function useMembers(params, options) {
    const queryOptions = useMembersQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const useRolesHook = () => {
    const roles = useWidgetsApiClient();
    return useCallback((signal) => {
        return roles({
            url: `/_widgets/UserManagement/roles`,
            method: "GET",
            signal,
        });
    }, [roles]);
};
export const getRolesQueryKey = () => {
    return [`/_widgets/UserManagement/roles`];
};
export const useRolesQueryOptions = (options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getRolesQueryKey();
    const roles = useRolesHook();
    const queryFn = ({ signal }) => roles(signal);
    const customOptions = useWidgetsApiQueryOptions({
        ...queryOptions,
        queryKey,
        queryFn,
    });
    return customOptions;
};
export function useRoles(options) {
    const queryOptions = useRolesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const useInviteMemberHook = () => {
    const inviteMember = useWidgetsApiClient();
    return useCallback((inviteMemberInput, signal) => {
        return inviteMember({
            url: `/_widgets/UserManagement/invite-user`,
            method: "POST",
            headers: { "Content-Type": "application/json" },
            data: inviteMemberInput,
            signal,
        });
    }, [inviteMember]);
};
export const useInviteMemberMutationOptions = (options) => {
    const mutationKey = ["inviteMember"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const inviteMember = useInviteMemberHook();
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return inviteMember(data);
    };
    return { mutationFn, ...mutationOptions };
};
export const useInviteMember = (options) => {
    const mutationOptions = useInviteMemberMutationOptions(options);
    return useMutation(mutationOptions);
};
export const useResendInviteHook = () => {
    const resendInvite = useWidgetsApiClient();
    return useCallback((userId, signal) => {
        return resendInvite({
            url: `/_widgets/UserManagement/invites/${userId}/resend`,
            method: "POST",
            signal,
        });
    }, [resendInvite]);
};
export const useResendInviteMutationOptions = (options) => {
    const mutationKey = ["resendInvite"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const resendInvite = useResendInviteHook();
    const mutationFn = (props) => {
        const { userId } = props ?? {};
        return resendInvite(userId);
    };
    return { mutationFn, ...mutationOptions };
};
export const useResendInvite = (options) => {
    const mutationOptions = useResendInviteMutationOptions(options);
    return useMutation(mutationOptions);
};
export const useRevokeInviteHook = () => {
    const revokeInvite = useWidgetsApiClient();
    return useCallback((userId) => {
        return revokeInvite({
            url: `/_widgets/UserManagement/invites/${userId}`,
            method: "DELETE",
        });
    }, [revokeInvite]);
};
export const useRevokeInviteMutationOptions = (options) => {
    const mutationKey = ["revokeInvite"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const revokeInvite = useRevokeInviteHook();
    const mutationFn = (props) => {
        const { userId } = props ?? {};
        return revokeInvite(userId);
    };
    return { mutationFn, ...mutationOptions };
};
export const useRevokeInvite = (options) => {
    const mutationOptions = useRevokeInviteMutationOptions(options);
    return useMutation(mutationOptions);
};
export const useRemoveMemberHook = () => {
    const removeMember = useWidgetsApiClient();
    return useCallback((userId) => {
        return removeMember({
            url: `/_widgets/UserManagement/members/${userId}`,
            method: "DELETE",
        });
    }, [removeMember]);
};
export const useRemoveMemberMutationOptions = (options) => {
    const mutationKey = ["removeMember"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const removeMember = useRemoveMemberHook();
    const mutationFn = (props) => {
        const { userId } = props ?? {};
        return removeMember(userId);
    };
    return { mutationFn, ...mutationOptions };
};
export const useRemoveMember = (options) => {
    const mutationOptions = useRemoveMemberMutationOptions(options);
    return useMutation(mutationOptions);
};
export const useUpdateMemberHook = () => {
    const updateMember = useWidgetsApiClient();
    return useCallback((userId, updateMemberInput, signal) => {
        return updateMember({
            url: `/_widgets/UserManagement/members/${userId}`,
            method: "POST",
            headers: { "Content-Type": "application/json" },
            data: updateMemberInput,
            signal,
        });
    }, [updateMember]);
};
export const useUpdateMemberMutationOptions = (options) => {
    const mutationKey = ["updateMember"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const updateMember = useUpdateMemberHook();
    const mutationFn = (props) => {
        const { userId, data } = props ?? {};
        return updateMember(userId, data);
    };
    return { mutationFn, ...mutationOptions };
};
export const useUpdateMember = (options) => {
    const mutationOptions = useUpdateMemberMutationOptions(options);
    return useMutation(mutationOptions);
};
export const useOrganizationsHook = () => {
    const organizations = useWidgetsApiClient();
    return useCallback((signal) => {
        return organizations({
            url: `/_widgets/UserManagement/organizations`,
            method: "GET",
            signal,
        });
    }, [organizations]);
};
export const getOrganizationsQueryKey = () => {
    return [`/_widgets/UserManagement/organizations`];
};
export const useOrganizationsQueryOptions = (options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getOrganizationsQueryKey();
    const organizations = useOrganizationsHook();
    const queryFn = ({ signal }) => organizations(signal);
    const customOptions = useWidgetsApiQueryOptions({
        ...queryOptions,
        queryKey,
        queryFn,
    });
    return customOptions;
};
export function useOrganizations(options) {
    const queryOptions = useOrganizationsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const useMeHook = () => {
    const me = useWidgetsApiClient();
    return useCallback((signal) => {
        return me({ url: `/_widgets/UserProfile/me`, method: "GET", signal });
    }, [me]);
};
export const getMeQueryKey = () => {
    return [`/_widgets/UserProfile/me`];
};
export const useMeQueryOptions = (options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getMeQueryKey();
    const me = useMeHook();
    const queryFn = ({ signal }) => me(signal);
    const customOptions = useWidgetsApiQueryOptions({
        ...queryOptions,
        queryKey,
        queryFn,
    });
    return customOptions;
};
export function useMe(options) {
    const queryOptions = useMeQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const useUpdateMeHook = () => {
    const updateMe = useWidgetsApiClient();
    return useCallback((updateMeInput, signal) => {
        return updateMe({
            url: `/_widgets/UserProfile/me`,
            method: "POST",
            headers: { "Content-Type": "application/json" },
            data: updateMeInput,
            signal,
        });
    }, [updateMe]);
};
export const useUpdateMeMutationOptions = (options) => {
    const mutationKey = ["updateMe"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const updateMe = useUpdateMeHook();
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return updateMe(data);
    };
    return { mutationFn, ...mutationOptions };
};
export const useUpdateMe = (options) => {
    const mutationOptions = useUpdateMeMutationOptions(options);
    return useMutation(mutationOptions);
};
export const useCreateTotpFactorHook = () => {
    const createTotpFactor = useWidgetsApiClient();
    return useCallback((signal) => {
        return createTotpFactor({
            url: `/_widgets/UserProfile/create-totp-factor`,
            method: "POST",
            signal,
        });
    }, [createTotpFactor]);
};
export const useCreateTotpFactorMutationOptions = (options) => {
    const mutationKey = ["createTotpFactor"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const createTotpFactor = useCreateTotpFactorHook();
    const mutationFn = () => {
        return createTotpFactor();
    };
    return { mutationFn, ...mutationOptions };
};
export const useCreateTotpFactor = (options) => {
    const mutationOptions = useCreateTotpFactorMutationOptions(options);
    return useMutation(mutationOptions);
};
export const useVerifyTotpFactorHook = () => {
    const verifyTotpFactor = useWidgetsApiClient();
    return useCallback((verifyTotpFactorRequest, signal) => {
        return verifyTotpFactor({
            url: `/_widgets/UserProfile/verify-totp-factor`,
            method: "POST",
            headers: { "Content-Type": "application/json" },
            data: verifyTotpFactorRequest,
            signal,
        });
    }, [verifyTotpFactor]);
};
export const useVerifyTotpFactorMutationOptions = (options) => {
    const mutationKey = ["verifyTotpFactor"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const verifyTotpFactor = useVerifyTotpFactorHook();
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return verifyTotpFactor(data);
    };
    return { mutationFn, ...mutationOptions };
};
export const useVerifyTotpFactor = (options) => {
    const mutationOptions = useVerifyTotpFactorMutationOptions(options);
    return useMutation(mutationOptions);
};
export const useDeleteTotpFactorsHook = () => {
    const deleteTotpFactors = useWidgetsApiClient();
    return useCallback(() => {
        return deleteTotpFactors({
            url: `/_widgets/UserProfile/totp-factors`,
            method: "DELETE",
        });
    }, [deleteTotpFactors]);
};
export const useDeleteTotpFactorsMutationOptions = (options) => {
    const mutationKey = ["deleteTotpFactors"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const deleteTotpFactors = useDeleteTotpFactorsHook();
    const mutationFn = () => {
        return deleteTotpFactors();
    };
    return { mutationFn, ...mutationOptions };
};
export const useDeleteTotpFactors = (options) => {
    const mutationOptions = useDeleteTotpFactorsMutationOptions(options);
    return useMutation(mutationOptions);
};
export const useAuthenticationInformationHook = () => {
    const authenticationInformation = useWidgetsApiClient();
    return useCallback((signal) => {
        return authenticationInformation({
            url: `/_widgets/UserProfile/authentication-information`,
            method: "GET",
            signal,
        });
    }, [authenticationInformation]);
};
export const getAuthenticationInformationQueryKey = () => {
    return [`/_widgets/UserProfile/authentication-information`];
};
export const useAuthenticationInformationQueryOptions = (options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getAuthenticationInformationQueryKey();
    const authenticationInformation = useAuthenticationInformationHook();
    const queryFn = ({ signal }) => authenticationInformation(signal);
    const customOptions = useWidgetsApiQueryOptions({
        ...queryOptions,
        queryKey,
        queryFn,
    });
    return customOptions;
};
export function useAuthenticationInformation(options) {
    const queryOptions = useAuthenticationInformationQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const useCreatePasswordHook = () => {
    const createPassword = useWidgetsApiClient();
    return useCallback((createPasswordRequest, signal) => {
        return createPassword({
            url: `/_widgets/UserProfile/create-password`,
            method: "POST",
            headers: { "Content-Type": "application/json" },
            data: createPasswordRequest,
            signal,
        });
    }, [createPassword]);
};
export const useCreatePasswordMutationOptions = (options) => {
    const mutationKey = ["createPassword"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const createPassword = useCreatePasswordHook();
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return createPassword(data);
    };
    return { mutationFn, ...mutationOptions };
};
export const useCreatePassword = (options) => {
    const mutationOptions = useCreatePasswordMutationOptions(options);
    return useMutation(mutationOptions);
};
export const useUpdatePasswordHook = () => {
    const updatePassword = useWidgetsApiClient();
    return useCallback((updatePasswordRequest, signal) => {
        return updatePassword({
            url: `/_widgets/UserProfile/update-password`,
            method: "POST",
            headers: { "Content-Type": "application/json" },
            data: updatePasswordRequest,
            signal,
        });
    }, [updatePassword]);
};
export const useUpdatePasswordMutationOptions = (options) => {
    const mutationKey = ["updatePassword"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const updatePassword = useUpdatePasswordHook();
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return updatePassword(data);
    };
    return { mutationFn, ...mutationOptions };
};
export const useUpdatePassword = (options) => {
    const mutationOptions = useUpdatePasswordMutationOptions(options);
    return useMutation(mutationOptions);
};
export const useRevokeAllSessionsHook = () => {
    const revokeAllSessions = useWidgetsApiClient();
    return useCallback((revokeAllSessionsRequest) => {
        return revokeAllSessions({
            url: `/_widgets/UserProfile/sessions/revoke-all`,
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
            data: revokeAllSessionsRequest,
        });
    }, [revokeAllSessions]);
};
export const useRevokeAllSessionsMutationOptions = (options) => {
    const mutationKey = ["revokeAllSessions"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const revokeAllSessions = useRevokeAllSessionsHook();
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return revokeAllSessions(data);
    };
    return { mutationFn, ...mutationOptions };
};
export const useRevokeAllSessions = (options) => {
    const mutationOptions = useRevokeAllSessionsMutationOptions(options);
    return useMutation(mutationOptions);
};
export const useRevokeSessionHook = () => {
    const revokeSession = useWidgetsApiClient();
    return useCallback((sessionId) => {
        return revokeSession({
            url: `/_widgets/UserProfile/sessions/revoke/${sessionId}`,
            method: "DELETE",
        });
    }, [revokeSession]);
};
export const useRevokeSessionMutationOptions = (options) => {
    const mutationKey = ["revokeSession"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const revokeSession = useRevokeSessionHook();
    const mutationFn = (props) => {
        const { sessionId } = props ?? {};
        return revokeSession(sessionId);
    };
    return { mutationFn, ...mutationOptions };
};
export const useRevokeSession = (options) => {
    const mutationOptions = useRevokeSessionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const useSessionsHook = () => {
    const sessions = useWidgetsApiClient();
    return useCallback((signal) => {
        return sessions({
            url: `/_widgets/UserProfile/sessions`,
            method: "GET",
            signal,
        });
    }, [sessions]);
};
export const getSessionsQueryKey = () => {
    return [`/_widgets/UserProfile/sessions`];
};
export const useSessionsQueryOptions = (options) => {
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getSessionsQueryKey();
    const sessions = useSessionsHook();
    const queryFn = ({ signal }) => sessions(signal);
    const customOptions = useWidgetsApiQueryOptions({
        ...queryOptions,
        queryKey,
        queryFn,
    });
    return customOptions;
};
export function useSessions(options) {
    const queryOptions = useSessionsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
}
export const useSendVerificationHook = () => {
    const sendVerification = useWidgetsApiClient();
    return useCallback((signal) => {
        return sendVerification({
            url: `/_widgets/UserProfile/send-verification`,
            method: "POST",
            signal,
        });
    }, [sendVerification]);
};
export const useSendVerificationMutationOptions = (options) => {
    const mutationKey = ["sendVerification"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const sendVerification = useSendVerificationHook();
    const mutationFn = () => {
        return sendVerification();
    };
    return { mutationFn, ...mutationOptions };
};
export const useSendVerification = (options) => {
    const mutationOptions = useSendVerificationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const useVerifyHook = () => {
    const verify = useWidgetsApiClient();
    return useCallback((verifyRequest, signal) => {
        return verify({
            url: `/_widgets/UserProfile/verify`,
            method: "POST",
            headers: { "Content-Type": "application/json" },
            data: verifyRequest,
            signal,
        });
    }, [verify]);
};
export const useVerifyMutationOptions = (options) => {
    const mutationKey = ["verify"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const verify = useVerifyHook();
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return verify(data);
    };
    return { mutationFn, ...mutationOptions };
};
export const useVerify = (options) => {
    const mutationOptions = useVerifyMutationOptions(options);
    return useMutation(mutationOptions);
};
export const useRegisterPasskeyHook = () => {
    const registerPasskey = useWidgetsApiClient();
    return useCallback((signal) => {
        return registerPasskey({
            url: `/_widgets/UserProfile/passkeys`,
            method: "POST",
            signal,
        });
    }, [registerPasskey]);
};
export const useRegisterPasskeyMutationOptions = (options) => {
    const mutationKey = ["registerPasskey"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const registerPasskey = useRegisterPasskeyHook();
    const mutationFn = () => {
        return registerPasskey();
    };
    return { mutationFn, ...mutationOptions };
};
export const useRegisterPasskey = (options) => {
    const mutationOptions = useRegisterPasskeyMutationOptions(options);
    return useMutation(mutationOptions);
};
export const useVerifyPasskeyHook = () => {
    const verifyPasskey = useWidgetsApiClient();
    return useCallback((verifyPasskeyRequest, signal) => {
        return verifyPasskey({
            url: `/_widgets/UserProfile/passkeys/verify`,
            method: "POST",
            headers: { "Content-Type": "application/json" },
            data: verifyPasskeyRequest,
            signal,
        });
    }, [verifyPasskey]);
};
export const useVerifyPasskeyMutationOptions = (options) => {
    const mutationKey = ["verifyPasskey"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const verifyPasskey = useVerifyPasskeyHook();
    const mutationFn = (props) => {
        const { data } = props ?? {};
        return verifyPasskey(data);
    };
    return { mutationFn, ...mutationOptions };
};
export const useVerifyPasskey = (options) => {
    const mutationOptions = useVerifyPasskeyMutationOptions(options);
    return useMutation(mutationOptions);
};
export const useDeletePasskeyHook = () => {
    const deletePasskey = useWidgetsApiClient();
    return useCallback((passkeyId) => {
        return deletePasskey({
            url: `/_widgets/UserProfile/passkeys/${passkeyId}`,
            method: "DELETE",
        });
    }, [deletePasskey]);
};
export const useDeletePasskeyMutationOptions = (options) => {
    const mutationKey = ["deletePasskey"];
    const { mutation: mutationOptions } = options
        ? options.mutation &&
            "mutationKey" in options.mutation &&
            options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };
    const deletePasskey = useDeletePasskeyHook();
    const mutationFn = (props) => {
        const { passkeyId } = props ?? {};
        return deletePasskey(passkeyId);
    };
    return { mutationFn, ...mutationOptions };
};
export const useDeletePasskey = (options) => {
    const mutationOptions = useDeletePasskeyMutationOptions(options);
    return useMutation(mutationOptions);
};
//# sourceMappingURL=endpoint.js.map